export default {
  namespaced: true,
  state: {
    // The Candidates currently visible
    active: [],
    // Used to indicate when waiting on the server
    loading: false,
    // The search string being applied
    search: '',
    // What filters are currently applied
    filters: {},
    // The total records matching the filter according to the server (for pagination)
    total: 0,
    // The current page being viewed and its size
    page: 1,
    rowsPerPage: 25,
    // Sorting
    sort: {
      by: 'updatedAt',
      descending: false
    }
  },
  getters: {
    find: state => id => state.active.find(candidate => candidate.id == id)
  },
  mutations: {
    setActive(
      state,
      {
        items = [],
        page = 1,
        per = 25,
        total = 0,
        search = null,
        sort = { by: 'updatedAt', descending: true },
        filters = {}
      }
    ) {
      state.search = search
      state.active = items.map(i => ({ ...i, $type: 'Candidate' }))
      state.sort = sort
      state.filters = filters
      state.page = page
      state.rowsPerPage = per
      state.total = total
      state.loading = false
    },
    set(state, candidate) {
      state.active = state.active.filter(o => o.id != candidate.id)
      state.active.push({ ...candidate, $type: 'Candidate' })
    },
    remove(state, id) {
      state.active = state.active.filter(o => o.id != id)
    }
  },
  actions: {
    search(
      { commit, state },
      { search = '', page = 1, rowsPerPage = 25, sortBy = 'updatedAt', descending = true, filters = {} }
    ) {
      const params = {
        search: search,
        page: page,
        per: rowsPerPage,
        sort: `${sortBy} ${descending ? 'DESC' : 'ASC'}`,
        ...filters
      }
      this.$authorize('list', 'Candidate')

      state.loading = true
      return Vue.$http
        .get('admin/candidates', { params })
        .then(response => commit('setActive', response.data), error => (state.loading = false))
    },
    fetch({ commit }, id) {
      this.$authorize('read', 'Candidate')

      return Vue.$http.get(`admin/candidates/${id}`).then(response => commit('set', response.data))
    },
    create({ commit }, candidate) {
      this.$authorize('create', 'Candidate')

      return Vue.$http.post('admin/candidates', { candidate }).then(
        response => {
          commit('set', response.data)
          return response.data
        },
        error => Object.assign(candidate, error.response.data)
      )
    },
    update({ commit }, candidate) {
      this.$authorize('edit', 'Candidate')

      return Vue.$http
        .patch(`admin/candidates/${candidate.id}`, { candidate })
        .then(
          response => commit('set', response.data),
          error => commit('set', Object.assign(candidate, error.response.data))
        )
    },
    destroy({ commit }, id) {
      this.$authorize('delete', 'Candidate')

      return Vue.$http.delete(`admin/candidates/${id}`).then(response => commit('remove', id))
    },
    reactivate({ commit }, id) {
      this.$authorize('edit', 'Candidate')

      return Vue.$http.get(`admin/candidates/${id}/reactivate`)
    },
    sendEmailConfirmation({ commit }, id) {
      this.$authorize('edit', 'Candidate')

      return Vue.$http.get(`admin/candidates/${id}/send_email_confirmation`)
    },
    manualConfirmation({ commit, state }, id) {
      this.$authorize('edit', 'Candidate')
      let candidate = state.active.find(candidate => candidate.id == id)

      return Vue.$http
        .patch(`admin/candidates/${candidate.id}`, { candidate: Object.assign(candidate, { confirmedAt: new Date() }) })
        .then(
          response => commit('set', response.data),
          error => commit('set', Object.assign(candidate, error.response.data))
        )
    },
    manualUnconfirmation({ commit, state }, id) {
      this.$authorize('edit', 'Candidate')
      let candidate = state.active.find(candidate => candidate.id == id)

      return Vue.$http
        .patch(`admin/candidates/${candidate.id}`, { candidate: Object.assign(candidate, { confirmedAt: null }) })
        .then(
          response => commit('set', response.data),
          error => commit('set', Object.assign(candidate, error.response.data))
        )
    },
  }
}
